import React, { useState } from 'react'
import { Collapse } from '@mui/material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import SensorAlarmSummary from './SensorAlarmSummary'
import SensorAlarmList from './SensorAlarmList'
import { getHeaderErrors } from './sensorAlarmUtils'

/**
 * DeviceGroupCompactCard — the whole header line of a group's framed section
 * (PO iteration: everything on ONE row): group name + visible-asset count on the
 * left, and the severity counters with the collapsible sensor alarm list on the
 * RIGHT (the old /monitoring GroupCard pattern, same `SensorAlarmSummary`/
 * `SensorAlarmList`/`sensorAlarmUtils` unchanged — RN12/RN14). Covers HU-06/CA8
 * embedded in the section frame.
 *
 * The per-device-type "operative" summary chips (RN15) are HIDDEN for now (PO
 * decision, pending final design) — `summarizeDeviceTypes` stays available in
 * plantMonitoringUtils for when they come back.
 */
export default function DeviceGroupCompactCard ({ title, count, sensorErrors = [] }) {
  const { t_ } = useSmartTranslation()
  const [alarmsOpen, setAlarmsOpen] = useState(false)

  const hasAlarm = getHeaderErrors(sensorErrors).length > 0

  return (
    <div data-testid='group-compact-card' style={{ marginBottom: 14 }}>
      <div className='mcx-groupsection__head' style={{ marginBottom: 0 }}>
        <h2 className='mcx-groupsection__name'>{title}</h2>
        <span className='mcx-groupsection__count'>{count}</span>

        <span className='mcx-groupsection__rule' />

        {hasAlarm
          ? (
            <SensorAlarmSummary errors={sensorErrors} open={alarmsOpen} onToggle={() => setAlarmsOpen((open) => !open)} />
            )
          : (
            <span data-testid='group-compact-alarms-zero' className='mcx-typechip'>
              {t_('Active alarms')}: 0
            </span>
            )}
      </div>

      {hasAlarm && (
        <Collapse in={alarmsOpen}>
          <SensorAlarmList errors={sensorErrors} />
        </Collapse>
      )}
    </div>
  )
}
